/**
 * Generated by orval 🍺
 * Do not edit manually.
 * BREEDER v2 API
 * OpenAPI spec version: 2.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Carrier,
  CarriersIn,
  EnvironmentValue,
  GenealogyEnvironmentsParams,
  GenealogyExportParams,
  GenealogyLociParams,
  GenealogyPerformanceParams,
  GenealogyPlacesParams,
  GenealogyPlotsParams,
  GenealogySheetParams,
  GenealogyTreeExportParams,
  GenealogyTreeParams,
  GenotypeSheet,
  HTTPValidationError,
  PedigreeTree,
  Place,
  PlotEntry,
  Rows,
  SeedPost,
  YearValue
} from '../model';

import { apiFetch } from '../../http';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGenealogyCarriersUrl = () => {




  return `/api/v1/genotypes/carriers`
}

/**
 * @summary Which of the genes (or alleles) each line carries and has results for (a tree's nodes)
 */
export const genealogyCarriers = async (carriersIn: CarriersIn, options?: Parameters<typeof apiFetch>[1]): Promise<Carrier[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<Carrier[]>(getGenealogyCarriersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(carriersIn)
  }
);}





export const getGenealogyCarriersMutationKey = () => ['genealogyCarriers'] as const;

export const getGenealogyCarriersMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof genealogyCarriers>>, TError,GenealogyCarriersMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof genealogyCarriers>>, TError,GenealogyCarriersMutationVariables, TContext> => {

const mutationKey = getGenealogyCarriersMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof genealogyCarriers>>, GenealogyCarriersMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  genealogyCarriers(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenealogyCarriersMutationResult = NonNullable<Awaited<ReturnType<typeof genealogyCarriers>>>
    export type GenealogyCarriersMutationBody = CarriersIn
    export type GenealogyCarriersMutationError = HTTPValidationError
    export type GenealogyCarriersMutationVariables = {data: CarriersIn}

    /**
 * @summary Which of the genes (or alleles) each line carries and has results for (a tree's nodes)
 */
export const useGenealogyCarriers = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof genealogyCarriers>>, TError,GenealogyCarriersMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof genealogyCarriers>>,
        TError,
        GenealogyCarriersMutationVariables,
        TContext
      > => {
      return useMutation(getGenealogyCarriersMutationOptions(options), queryClient);
    }
    export const getGenealogyLociUrl = (params?: GenealogyLociParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/genotypes/loci?${stringifiedParams}` : `/api/v1/genotypes/loci`
}

/**
 * @summary The markers a line can carry (the Genes matrix loci, the lab's genes), or every allele
 */
export const genealogyLoci = async (params?: GenealogyLociParams, options?: Parameters<typeof apiFetch>[1]): Promise<string[]> => {

  return apiFetch<string[]>(getGenealogyLociUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGenealogyLociQueryKey = (params?: GenealogyLociParams,) => {
    return [
    `/api/v1/genotypes/loci`, ...(params ? [params] : [])
    ] as const;
    }


export const getGenealogyLociQueryOptions = <TData = Awaited<ReturnType<typeof genealogyLoci>>, TError = HTTPValidationError>(params?: GenealogyLociParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyLoci>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGenealogyLociQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof genealogyLoci>>> = ({ signal }) => genealogyLoci(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof genealogyLoci>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GenealogyLociQueryResult = NonNullable<Awaited<ReturnType<typeof genealogyLoci>>>
export type GenealogyLociQueryError = HTTPValidationError


export function useGenealogyLoci<TData = Awaited<ReturnType<typeof genealogyLoci>>, TError = HTTPValidationError>(
 params: undefined |  GenealogyLociParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyLoci>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof genealogyLoci>>,
          TError,
          Awaited<ReturnType<typeof genealogyLoci>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGenealogyLoci<TData = Awaited<ReturnType<typeof genealogyLoci>>, TError = HTTPValidationError>(
 params?: GenealogyLociParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyLoci>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof genealogyLoci>>,
          TError,
          Awaited<ReturnType<typeof genealogyLoci>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGenealogyLoci<TData = Awaited<ReturnType<typeof genealogyLoci>>, TError = HTTPValidationError>(
 params?: GenealogyLociParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyLoci>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The markers a line can carry (the Genes matrix loci, the lab's genes), or every allele
 */

export function useGenealogyLoci<TData = Awaited<ReturnType<typeof genealogyLoci>>, TError = HTTPValidationError>(
 params?: GenealogyLociParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyLoci>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGenealogyLociQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGenealogySheetUrl = (paz: number,
    sid: number,
    params: GenealogySheetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/genotypes/${paz}/${sid}?${stringifiedParams}` : `/api/v1/genotypes/${paz}/${sid}`
}

/**
 * @summary A line's sheet: register record, summary, sister lines, parents, ancestry, markers
 */
export const genealogySheet = async (paz: number,
    sid: number,
    params: GenealogySheetParams, options?: Parameters<typeof apiFetch>[1]): Promise<GenotypeSheet> => {

  return apiFetch<GenotypeSheet>(getGenealogySheetUrl(paz,sid,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGenealogySheetQueryKey = (paz: number,
    sid: number,
    params?: GenealogySheetParams,) => {
    return [
    `/api/v1/genotypes/${paz}/${sid}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGenealogySheetQueryOptions = <TData = Awaited<ReturnType<typeof genealogySheet>>, TError = HTTPValidationError>(paz: number,
    sid: number,
    params: GenealogySheetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogySheet>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGenealogySheetQueryKey(paz,sid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof genealogySheet>>> = ({ signal }) => genealogySheet(paz,sid,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: paz !== null && paz !== undefined && sid !== null && sid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof genealogySheet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GenealogySheetQueryResult = NonNullable<Awaited<ReturnType<typeof genealogySheet>>>
export type GenealogySheetQueryError = HTTPValidationError


export function useGenealogySheet<TData = Awaited<ReturnType<typeof genealogySheet>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params: GenealogySheetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogySheet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof genealogySheet>>,
          TError,
          Awaited<ReturnType<typeof genealogySheet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGenealogySheet<TData = Awaited<ReturnType<typeof genealogySheet>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params: GenealogySheetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogySheet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof genealogySheet>>,
          TError,
          Awaited<ReturnType<typeof genealogySheet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGenealogySheet<TData = Awaited<ReturnType<typeof genealogySheet>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params: GenealogySheetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogySheet>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary A line's sheet: register record, summary, sister lines, parents, ancestry, markers
 */

export function useGenealogySheet<TData = Awaited<ReturnType<typeof genealogySheet>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params: GenealogySheetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogySheet>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGenealogySheetQueryOptions(paz,sid,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGenealogyEnvironmentsUrl = (paz: number,
    sid: number,
    params?: GenealogyEnvironmentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["fields"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/genotypes/${paz}/${sid}/environments?${stringifiedParams}` : `/api/v1/genotypes/${paz}/${sid}/environments`
}

/**
 * @summary Performance separated by year, trial and site (subplot zero)
 */
export const genealogyEnvironments = async (paz: number,
    sid: number,
    params?: GenealogyEnvironmentsParams, options?: Parameters<typeof apiFetch>[1]): Promise<EnvironmentValue[]> => {

  return apiFetch<EnvironmentValue[]>(getGenealogyEnvironmentsUrl(paz,sid,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGenealogyEnvironmentsQueryKey = (paz: number,
    sid: number,
    params?: GenealogyEnvironmentsParams,) => {
    return [
    `/api/v1/genotypes/${paz}/${sid}/environments`, ...(params ? [params] : [])
    ] as const;
    }


export const getGenealogyEnvironmentsQueryOptions = <TData = Awaited<ReturnType<typeof genealogyEnvironments>>, TError = HTTPValidationError>(paz: number,
    sid: number,
    params?: GenealogyEnvironmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyEnvironments>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGenealogyEnvironmentsQueryKey(paz,sid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof genealogyEnvironments>>> = ({ signal }) => genealogyEnvironments(paz,sid,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: paz !== null && paz !== undefined && sid !== null && sid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof genealogyEnvironments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GenealogyEnvironmentsQueryResult = NonNullable<Awaited<ReturnType<typeof genealogyEnvironments>>>
export type GenealogyEnvironmentsQueryError = HTTPValidationError


export function useGenealogyEnvironments<TData = Awaited<ReturnType<typeof genealogyEnvironments>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params: undefined |  GenealogyEnvironmentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyEnvironments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof genealogyEnvironments>>,
          TError,
          Awaited<ReturnType<typeof genealogyEnvironments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGenealogyEnvironments<TData = Awaited<ReturnType<typeof genealogyEnvironments>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params?: GenealogyEnvironmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyEnvironments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof genealogyEnvironments>>,
          TError,
          Awaited<ReturnType<typeof genealogyEnvironments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGenealogyEnvironments<TData = Awaited<ReturnType<typeof genealogyEnvironments>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params?: GenealogyEnvironmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyEnvironments>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Performance separated by year, trial and site (subplot zero)
 */

export function useGenealogyEnvironments<TData = Awaited<ReturnType<typeof genealogyEnvironments>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params?: GenealogyEnvironmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyEnvironments>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGenealogyEnvironmentsQueryOptions(paz,sid,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGenealogyExportUrl = (paz: number,
    sid: number,
    params: GenealogyExportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/genotypes/${paz}/${sid}/export?${stringifiedParams}` : `/api/v1/genotypes/${paz}/${sid}/export`
}

/**
 * @summary Everything about the line as an .xlsx file
 */
export const genealogyExport = async (paz: number,
    sid: number,
    params: GenealogyExportParams, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getGenealogyExportUrl(paz,sid,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGenealogyExportQueryKey = (paz: number,
    sid: number,
    params?: GenealogyExportParams,) => {
    return [
    `/api/v1/genotypes/${paz}/${sid}/export`, ...(params ? [params] : [])
    ] as const;
    }


export const getGenealogyExportQueryOptions = <TData = Awaited<ReturnType<typeof genealogyExport>>, TError = HTTPValidationError>(paz: number,
    sid: number,
    params: GenealogyExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyExport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGenealogyExportQueryKey(paz,sid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof genealogyExport>>> = ({ signal }) => genealogyExport(paz,sid,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: paz !== null && paz !== undefined && sid !== null && sid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof genealogyExport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GenealogyExportQueryResult = NonNullable<Awaited<ReturnType<typeof genealogyExport>>>
export type GenealogyExportQueryError = HTTPValidationError


export function useGenealogyExport<TData = Awaited<ReturnType<typeof genealogyExport>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params: GenealogyExportParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyExport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof genealogyExport>>,
          TError,
          Awaited<ReturnType<typeof genealogyExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGenealogyExport<TData = Awaited<ReturnType<typeof genealogyExport>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params: GenealogyExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyExport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof genealogyExport>>,
          TError,
          Awaited<ReturnType<typeof genealogyExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGenealogyExport<TData = Awaited<ReturnType<typeof genealogyExport>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params: GenealogyExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyExport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Everything about the line as an .xlsx file
 */

export function useGenealogyExport<TData = Awaited<ReturnType<typeof genealogyExport>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params: GenealogyExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyExport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGenealogyExportQueryOptions(paz,sid,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGenealogyPerformanceUrl = (paz: number,
    sid: number,
    params?: GenealogyPerformanceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["fields"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/genotypes/${paz}/${sid}/performance?${stringifiedParams}` : `/api/v1/genotypes/${paz}/${sid}/performance`
}

/**
 * @summary The line's yearly means next to the means of the trials it grew in
 */
export const genealogyPerformance = async (paz: number,
    sid: number,
    params?: GenealogyPerformanceParams, options?: Parameters<typeof apiFetch>[1]): Promise<YearValue[]> => {

  return apiFetch<YearValue[]>(getGenealogyPerformanceUrl(paz,sid,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGenealogyPerformanceQueryKey = (paz: number,
    sid: number,
    params?: GenealogyPerformanceParams,) => {
    return [
    `/api/v1/genotypes/${paz}/${sid}/performance`, ...(params ? [params] : [])
    ] as const;
    }


export const getGenealogyPerformanceQueryOptions = <TData = Awaited<ReturnType<typeof genealogyPerformance>>, TError = HTTPValidationError>(paz: number,
    sid: number,
    params?: GenealogyPerformanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyPerformance>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGenealogyPerformanceQueryKey(paz,sid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof genealogyPerformance>>> = ({ signal }) => genealogyPerformance(paz,sid,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: paz !== null && paz !== undefined && sid !== null && sid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof genealogyPerformance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GenealogyPerformanceQueryResult = NonNullable<Awaited<ReturnType<typeof genealogyPerformance>>>
export type GenealogyPerformanceQueryError = HTTPValidationError


export function useGenealogyPerformance<TData = Awaited<ReturnType<typeof genealogyPerformance>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params: undefined |  GenealogyPerformanceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyPerformance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof genealogyPerformance>>,
          TError,
          Awaited<ReturnType<typeof genealogyPerformance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGenealogyPerformance<TData = Awaited<ReturnType<typeof genealogyPerformance>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params?: GenealogyPerformanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyPerformance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof genealogyPerformance>>,
          TError,
          Awaited<ReturnType<typeof genealogyPerformance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGenealogyPerformance<TData = Awaited<ReturnType<typeof genealogyPerformance>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params?: GenealogyPerformanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyPerformance>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The line's yearly means next to the means of the trials it grew in
 */

export function useGenealogyPerformance<TData = Awaited<ReturnType<typeof genealogyPerformance>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params?: GenealogyPerformanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyPerformance>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGenealogyPerformanceQueryOptions(paz,sid,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGenealogyPlacesUrl = (paz: number,
    sid: number,
    params: GenealogyPlacesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/genotypes/${paz}/${sid}/places?${stringifiedParams}` : `/api/v1/genotypes/${paz}/${sid}/places`
}

/**
 * @summary Where the line is in a year: trials and sites (mean, % of the checks), gene bank
 */
export const genealogyPlaces = async (paz: number,
    sid: number,
    params: GenealogyPlacesParams, options?: Parameters<typeof apiFetch>[1]): Promise<Place[]> => {

  return apiFetch<Place[]>(getGenealogyPlacesUrl(paz,sid,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGenealogyPlacesQueryKey = (paz: number,
    sid: number,
    params?: GenealogyPlacesParams,) => {
    return [
    `/api/v1/genotypes/${paz}/${sid}/places`, ...(params ? [params] : [])
    ] as const;
    }


export const getGenealogyPlacesQueryOptions = <TData = Awaited<ReturnType<typeof genealogyPlaces>>, TError = HTTPValidationError>(paz: number,
    sid: number,
    params: GenealogyPlacesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyPlaces>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGenealogyPlacesQueryKey(paz,sid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof genealogyPlaces>>> = ({ signal }) => genealogyPlaces(paz,sid,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: paz !== null && paz !== undefined && sid !== null && sid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof genealogyPlaces>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GenealogyPlacesQueryResult = NonNullable<Awaited<ReturnType<typeof genealogyPlaces>>>
export type GenealogyPlacesQueryError = HTTPValidationError


export function useGenealogyPlaces<TData = Awaited<ReturnType<typeof genealogyPlaces>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params: GenealogyPlacesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyPlaces>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof genealogyPlaces>>,
          TError,
          Awaited<ReturnType<typeof genealogyPlaces>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGenealogyPlaces<TData = Awaited<ReturnType<typeof genealogyPlaces>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params: GenealogyPlacesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyPlaces>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof genealogyPlaces>>,
          TError,
          Awaited<ReturnType<typeof genealogyPlaces>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGenealogyPlaces<TData = Awaited<ReturnType<typeof genealogyPlaces>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params: GenealogyPlacesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyPlaces>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Where the line is in a year: trials and sites (mean, % of the checks), gene bank
 */

export function useGenealogyPlaces<TData = Awaited<ReturnType<typeof genealogyPlaces>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params: GenealogyPlacesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyPlaces>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGenealogyPlacesQueryOptions(paz,sid,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGenealogyPlotsUrl = (paz: number,
    sid: number,
    params?: GenealogyPlotsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/genotypes/${paz}/${sid}/plots?${stringifiedParams}` : `/api/v1/genotypes/${paz}/${sid}/plots`
}

/**
 * @summary Every plot of the line, the newest first
 */
export const genealogyPlots = async (paz: number,
    sid: number,
    params?: GenealogyPlotsParams, options?: Parameters<typeof apiFetch>[1]): Promise<PlotEntry[]> => {

  return apiFetch<PlotEntry[]>(getGenealogyPlotsUrl(paz,sid,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGenealogyPlotsQueryKey = (paz: number,
    sid: number,
    params?: GenealogyPlotsParams,) => {
    return [
    `/api/v1/genotypes/${paz}/${sid}/plots`, ...(params ? [params] : [])
    ] as const;
    }


export const getGenealogyPlotsQueryOptions = <TData = Awaited<ReturnType<typeof genealogyPlots>>, TError = HTTPValidationError>(paz: number,
    sid: number,
    params?: GenealogyPlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyPlots>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGenealogyPlotsQueryKey(paz,sid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof genealogyPlots>>> = ({ signal }) => genealogyPlots(paz,sid,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: paz !== null && paz !== undefined && sid !== null && sid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof genealogyPlots>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GenealogyPlotsQueryResult = NonNullable<Awaited<ReturnType<typeof genealogyPlots>>>
export type GenealogyPlotsQueryError = HTTPValidationError


export function useGenealogyPlots<TData = Awaited<ReturnType<typeof genealogyPlots>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params: undefined |  GenealogyPlotsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyPlots>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof genealogyPlots>>,
          TError,
          Awaited<ReturnType<typeof genealogyPlots>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGenealogyPlots<TData = Awaited<ReturnType<typeof genealogyPlots>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params?: GenealogyPlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyPlots>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof genealogyPlots>>,
          TError,
          Awaited<ReturnType<typeof genealogyPlots>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGenealogyPlots<TData = Awaited<ReturnType<typeof genealogyPlots>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params?: GenealogyPlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyPlots>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every plot of the line, the newest first
 */

export function useGenealogyPlots<TData = Awaited<ReturnType<typeof genealogyPlots>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params?: GenealogyPlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyPlots>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGenealogyPlotsQueryOptions(paz,sid,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGenealogyRowsUrl = (paz: number,
    sid: number,
    table: string,) => {




  return `/api/v1/genotypes/${paz}/${sid}/rows/${table}`
}

/**
 * @summary The line's rows of koll, magkuldes, magerkezes, dna_source with the legacy column labels
 */
export const genealogyRows = async (paz: number,
    sid: number,
    table: string, options?: Parameters<typeof apiFetch>[1]): Promise<Rows> => {

  return apiFetch<Rows>(getGenealogyRowsUrl(paz,sid,table),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGenealogyRowsQueryKey = (paz: number,
    sid: number,
    table: string,) => {
    return [
    `/api/v1/genotypes/${paz}/${sid}/rows/${table}`
    ] as const;
    }


export const getGenealogyRowsQueryOptions = <TData = Awaited<ReturnType<typeof genealogyRows>>, TError = HTTPValidationError>(paz: number,
    sid: number,
    table: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyRows>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGenealogyRowsQueryKey(paz,sid,table);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof genealogyRows>>> = ({ signal }) => genealogyRows(paz,sid,table, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: paz !== null && paz !== undefined && sid !== null && sid !== undefined && table !== null && table !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof genealogyRows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GenealogyRowsQueryResult = NonNullable<Awaited<ReturnType<typeof genealogyRows>>>
export type GenealogyRowsQueryError = HTTPValidationError


export function useGenealogyRows<TData = Awaited<ReturnType<typeof genealogyRows>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    table: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyRows>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof genealogyRows>>,
          TError,
          Awaited<ReturnType<typeof genealogyRows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGenealogyRows<TData = Awaited<ReturnType<typeof genealogyRows>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    table: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyRows>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof genealogyRows>>,
          TError,
          Awaited<ReturnType<typeof genealogyRows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGenealogyRows<TData = Awaited<ReturnType<typeof genealogyRows>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    table: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyRows>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The line's rows of koll, magkuldes, magerkezes, dna_source with the legacy column labels
 */

export function useGenealogyRows<TData = Awaited<ReturnType<typeof genealogyRows>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    table: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyRows>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGenealogyRowsQueryOptions(paz,sid,table,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGenealogySeedPostUrl = (paz: number,
    sid: number,) => {




  return `/api/v1/genotypes/${paz}/${sid}/seed-post`
}

/**
 * @summary The line's MagPosta: shipments and arrivals by number, with their partners
 */
export const genealogySeedPost = async (paz: number,
    sid: number, options?: Parameters<typeof apiFetch>[1]): Promise<SeedPost> => {

  return apiFetch<SeedPost>(getGenealogySeedPostUrl(paz,sid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGenealogySeedPostQueryKey = (paz: number,
    sid: number,) => {
    return [
    `/api/v1/genotypes/${paz}/${sid}/seed-post`
    ] as const;
    }


export const getGenealogySeedPostQueryOptions = <TData = Awaited<ReturnType<typeof genealogySeedPost>>, TError = HTTPValidationError>(paz: number,
    sid: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogySeedPost>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGenealogySeedPostQueryKey(paz,sid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof genealogySeedPost>>> = ({ signal }) => genealogySeedPost(paz,sid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: paz !== null && paz !== undefined && sid !== null && sid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof genealogySeedPost>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GenealogySeedPostQueryResult = NonNullable<Awaited<ReturnType<typeof genealogySeedPost>>>
export type GenealogySeedPostQueryError = HTTPValidationError


export function useGenealogySeedPost<TData = Awaited<ReturnType<typeof genealogySeedPost>>, TError = HTTPValidationError>(
 paz: number,
    sid: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogySeedPost>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof genealogySeedPost>>,
          TError,
          Awaited<ReturnType<typeof genealogySeedPost>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGenealogySeedPost<TData = Awaited<ReturnType<typeof genealogySeedPost>>, TError = HTTPValidationError>(
 paz: number,
    sid: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogySeedPost>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof genealogySeedPost>>,
          TError,
          Awaited<ReturnType<typeof genealogySeedPost>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGenealogySeedPost<TData = Awaited<ReturnType<typeof genealogySeedPost>>, TError = HTTPValidationError>(
 paz: number,
    sid: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogySeedPost>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The line's MagPosta: shipments and arrivals by number, with their partners
 */

export function useGenealogySeedPost<TData = Awaited<ReturnType<typeof genealogySeedPost>>, TError = HTTPValidationError>(
 paz: number,
    sid: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogySeedPost>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGenealogySeedPostQueryOptions(paz,sid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGenealogyTreeUrl = (paz: number,
    sid: number,
    params?: GenealogyTreeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/genotypes/${paz}/${sid}/tree?${stringifiedParams}` : `/api/v1/genotypes/${paz}/${sid}/tree`
}

/**
 * @summary The pedigree tree (recorded crosses, else the pedigree text) and the ancestry
 */
export const genealogyTree = async (paz: number,
    sid: number,
    params?: GenealogyTreeParams, options?: Parameters<typeof apiFetch>[1]): Promise<PedigreeTree> => {

  return apiFetch<PedigreeTree>(getGenealogyTreeUrl(paz,sid,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGenealogyTreeQueryKey = (paz: number,
    sid: number,
    params?: GenealogyTreeParams,) => {
    return [
    `/api/v1/genotypes/${paz}/${sid}/tree`, ...(params ? [params] : [])
    ] as const;
    }


export const getGenealogyTreeQueryOptions = <TData = Awaited<ReturnType<typeof genealogyTree>>, TError = HTTPValidationError>(paz: number,
    sid: number,
    params?: GenealogyTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyTree>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGenealogyTreeQueryKey(paz,sid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof genealogyTree>>> = ({ signal }) => genealogyTree(paz,sid,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: paz !== null && paz !== undefined && sid !== null && sid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof genealogyTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GenealogyTreeQueryResult = NonNullable<Awaited<ReturnType<typeof genealogyTree>>>
export type GenealogyTreeQueryError = HTTPValidationError


export function useGenealogyTree<TData = Awaited<ReturnType<typeof genealogyTree>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params: undefined |  GenealogyTreeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyTree>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof genealogyTree>>,
          TError,
          Awaited<ReturnType<typeof genealogyTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGenealogyTree<TData = Awaited<ReturnType<typeof genealogyTree>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params?: GenealogyTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyTree>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof genealogyTree>>,
          TError,
          Awaited<ReturnType<typeof genealogyTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGenealogyTree<TData = Awaited<ReturnType<typeof genealogyTree>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params?: GenealogyTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyTree>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The pedigree tree (recorded crosses, else the pedigree text) and the ancestry
 */

export function useGenealogyTree<TData = Awaited<ReturnType<typeof genealogyTree>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params?: GenealogyTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyTree>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGenealogyTreeQueryOptions(paz,sid,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGenealogyTreeExportUrl = (paz: number,
    sid: number,
    params?: GenealogyTreeExportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/genotypes/${paz}/${sid}/tree/export?${stringifiedParams}` : `/api/v1/genotypes/${paz}/${sid}/tree/export`
}

/**
 * @summary The tree's ancestors (summed, or the last level) as an .xlsx file
 */
export const genealogyTreeExport = async (paz: number,
    sid: number,
    params?: GenealogyTreeExportParams, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getGenealogyTreeExportUrl(paz,sid,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGenealogyTreeExportQueryKey = (paz: number,
    sid: number,
    params?: GenealogyTreeExportParams,) => {
    return [
    `/api/v1/genotypes/${paz}/${sid}/tree/export`, ...(params ? [params] : [])
    ] as const;
    }


export const getGenealogyTreeExportQueryOptions = <TData = Awaited<ReturnType<typeof genealogyTreeExport>>, TError = HTTPValidationError>(paz: number,
    sid: number,
    params?: GenealogyTreeExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyTreeExport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGenealogyTreeExportQueryKey(paz,sid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof genealogyTreeExport>>> = ({ signal }) => genealogyTreeExport(paz,sid,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: paz !== null && paz !== undefined && sid !== null && sid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof genealogyTreeExport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GenealogyTreeExportQueryResult = NonNullable<Awaited<ReturnType<typeof genealogyTreeExport>>>
export type GenealogyTreeExportQueryError = HTTPValidationError


export function useGenealogyTreeExport<TData = Awaited<ReturnType<typeof genealogyTreeExport>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params: undefined |  GenealogyTreeExportParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyTreeExport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof genealogyTreeExport>>,
          TError,
          Awaited<ReturnType<typeof genealogyTreeExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGenealogyTreeExport<TData = Awaited<ReturnType<typeof genealogyTreeExport>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params?: GenealogyTreeExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyTreeExport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof genealogyTreeExport>>,
          TError,
          Awaited<ReturnType<typeof genealogyTreeExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGenealogyTreeExport<TData = Awaited<ReturnType<typeof genealogyTreeExport>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params?: GenealogyTreeExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyTreeExport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The tree's ancestors (summed, or the last level) as an .xlsx file
 */

export function useGenealogyTreeExport<TData = Awaited<ReturnType<typeof genealogyTreeExport>>, TError = HTTPValidationError>(
 paz: number,
    sid: number,
    params?: GenealogyTreeExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof genealogyTreeExport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGenealogyTreeExportQueryOptions(paz,sid,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






